import { GuidanceBox, H1, Text } from '@betterment/samba-react';
import { SambaAutoLink } from '@betterment/shared-components';

export const AutomatedInvestingGuidanceBox: React.FC = () => {
  return (
    <GuidanceBox css={{ marginBottom: 'space.300', width: '100%', maxWidth: 'none' }}>
      <GuidanceBox.Icon />
      <GuidanceBox.Header>
        <H1 variant="title100">Want more guidance?</H1>
      </GuidanceBox.Header>
      <GuidanceBox.Content>
        <Text variant="text50">
          Automated investing gives you global diversification with tax-saving technology and ongoing guidance at a low
          fee.{' '}
          <SambaAutoLink to="https://www.betterment.com/pricing" target="_blank">
            Learn more
          </SambaAutoLink>
        </Text>
      </GuidanceBox.Content>
    </GuidanceBox>
  );
};
